<template>
  <div class="input-group input-group-outline mb-3" :class="classObject">
    <i class="icon-text-input" :class="inputType.icon"></i>
    <label class="form-label">{{ label }}</label>
    <input
      :type="inputType.type"
      :id="id"
      ref="inputRef"
      class="form-control my-form-control"
      :maxlength="maxlength"
      :minlength="minlength"
      :autocomplete="autocomplete"
      :value="contentType === 16 ? monthName : value"
      @blur="handleInput"
      :readonly="isReadOnly"
      :class="classObject"
      :disabled="contentType===15 || contentType===16 || isBlocked === true"
    />
    <span v-if="errorMessage" class="error-message">{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: Boolean, required: false, default: false },
    value: { type: String, required: false, default: "" },
    id: { type: String, required: false, default: "" },
    label: { type: String, required: false, default: "" },
    placeholder: { type: String, required: false, default: "" },
    c_css: { type: String, required: false, default: "" },
    maxlength: { type: String, required: false, default: "" },
    minlength: { type: String, required: false, default: "" },
    autocomplete: { type: String, required: false, default: "" },
    contentType: { type: [Number, String], required: true },
    userAdmin: { type: [Number, String], required: false }
  },
  data() {
    return {
      focused: false,
      isReadOnly: true,
      errorMessage: "",
      isInvalid: false // Novo estado para validação
    };
  },
  computed: {
    isBlocked(){
        if(this.userAdmin != null && this.userAdmin != 1){
          return true;
        }
        return false;
    },
    inputType() {
      switch (this.contentType) {
        case 1:
          return { type: "text", format: "text", icon: "bx bx-text" };
        case 2:
        case 12:
          //return { type: "text", format: "number", icon: "bx-calculator" };
          return { type: "text", format: "number", icon: "mdi mdi-numeric" };

        case 3:
          return { type: "text", format: "email", icon: "bx bx-at" };
        case 4:
          return { type: "text", format: "tel", icon: "bx bx-phone" };
        case 5:
          return { type: "text", format: "tel", icon: "bx bx-link" };
        case 15:
          return {
            type: "text",
            format: "number",
            icon: "bx bx-calculator"
          };
        case 16:
          return {
            type: "text",
            format: "number",
            icon: "bx bx-calendar-check"
          };
        default:
          return { type: "text", format: "text", icon: "bx bx-text" };
      }
    },
    classObject() {
      return {
        "focused is-focused": this.focused,
        "is-filled": this.value,
        "input-error": this.isInvalid, // Adicionado baseado no estado de validação
        "my-input-disabled": this.contentType === 15 || this.contentType===16 ||this.isBlocked === true,
        text: this.contentType === 1,
        number: this.contentType === 2,
        email: this.contentType === 3,
        phone: this.contentType === 4,
        url: this.contentType === 5,
        total: this.contentType === 12
      };
    },
    monthName() {
      if (this.contentType !== 16 || isNaN(this.value)) {
        return this.value;
      }
      const monthNames = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ];
      const monthIndex = parseInt(this.value, 10) - 1;
      return monthNames[monthIndex] || this.value;
    }
  },
  methods: {
    handleInput(event) {
      let value = event.target.value;
      const id = event.target.id;

      if (this.contentType === 2 || this.contentType === 12) {
        value = value.replace(/\D/g, "");
        this.isInvalid = !(value === "" || /^\d+$/.test(value));
        this.$emit("input", value, id);
      } else {
        // Se não for numérico, não definir validade aqui
        this.isInvalid = false;
        this.$emit("input", value, id);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.isReadOnly = false;
    }, 500);
  }
};
</script>

<style scoped>
.icon-text-input {
  position: absolute;
  left: 12px;
  top: 13px;
  z-index: 3;
  font-size: 16px;
  color: #ccc;
}
.form-control {
  padding-left: 40px;
}
input.input-error {
  border: 1px solid red;
}
</style>